document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll('.about-lp__image').forEach((image) => {
    const isDelayed =
      image.classList.contains('about-lp__image--top-left') ||
      image.classList.contains('about-lp__image--bottom-right');

    gsap.fromTo(
      image,
      { scale: 0.8 },
      {
        scale: 1,
        duration: 0.8,
        delay: isDelayed ? 0.4 : 0,
        ease: 'power3.inOut',
        scrollTrigger: {
          trigger: image,
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
      }
    );
  });
});
